/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: InvoicesSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: InvoicesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { InvoicesData, InvoicesService }  from './Invoices.service';


@Component({
  selector: 'InvoicesSearch',
  template: require('./InvoicesSearch.component.html'),
  providers: [InvoicesService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class InvoicesSearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objInvoices: InvoicesData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private InvoicesService: InvoicesService

	) {
		// this.id = parseInt(params.get('id'));
		this.objInvoices = new InvoicesData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objInvoices = new InvoicesData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objInvoices.ShipName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipName like '%" + this.objInvoices.ShipName + "%'";
			else
				this.filterExpression = "ShipName like '%" + this.objInvoices.ShipName + "%'";
		}
		if (this.objInvoices.ShipAddress)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipAddress like '%" + this.objInvoices.ShipAddress + "%'";
			else
				this.filterExpression = "ShipAddress like '%" + this.objInvoices.ShipAddress + "%'";
		}
		if (this.objInvoices.ShipCity)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipCity like '%" + this.objInvoices.ShipCity + "%'";
			else
				this.filterExpression = "ShipCity like '%" + this.objInvoices.ShipCity + "%'";
		}
		if (this.objInvoices.ShipRegion)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipRegion like '%" + this.objInvoices.ShipRegion + "%'";
			else
				this.filterExpression = "ShipRegion like '%" + this.objInvoices.ShipRegion + "%'";
		}
		if (this.objInvoices.ShipPostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipPostalCode like '%" + this.objInvoices.ShipPostalCode + "%'";
			else
				this.filterExpression = "ShipPostalCode like '%" + this.objInvoices.ShipPostalCode + "%'";
		}
		if (this.objInvoices.ShipCountry)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipCountry like '%" + this.objInvoices.ShipCountry + "%'";
			else
				this.filterExpression = "ShipCountry like '%" + this.objInvoices.ShipCountry + "%'";
		}
		if (this.objInvoices.CustomerID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objInvoices.CustomerID + "%'";
			else
				this.filterExpression = "CustomerID like '%" + this.objInvoices.CustomerID + "%'";
		}
		if (this.objInvoices.CustomerName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CustomerName like '%" + this.objInvoices.CustomerName + "%'";
			else
				this.filterExpression = "CustomerName like '%" + this.objInvoices.CustomerName + "%'";
		}
		if (this.objInvoices.Address)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Address like '%" + this.objInvoices.Address + "%'";
			else
				this.filterExpression = "Address like '%" + this.objInvoices.Address + "%'";
		}
		if (this.objInvoices.City)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND City like '%" + this.objInvoices.City + "%'";
			else
				this.filterExpression = "City like '%" + this.objInvoices.City + "%'";
		}
		if (this.objInvoices.Region)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Region like '%" + this.objInvoices.Region + "%'";
			else
				this.filterExpression = "Region like '%" + this.objInvoices.Region + "%'";
		}
		if (this.objInvoices.PostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objInvoices.PostalCode + "%'";
			else
				this.filterExpression = "PostalCode like '%" + this.objInvoices.PostalCode + "%'";
		}
		if (this.objInvoices.Country)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Country like '%" + this.objInvoices.Country + "%'";
			else
				this.filterExpression = "Country like '%" + this.objInvoices.Country + "%'";
		}
		if (this.objInvoices.Salesperson)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Salesperson like '%" + this.objInvoices.Salesperson + "%'";
			else
				this.filterExpression = "Salesperson like '%" + this.objInvoices.Salesperson + "%'";
		}
		if (this.objInvoices.OrderID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND OrderID = " + this.objInvoices.OrderID;
			else
				this.filterExpression = "OrderID = " + this.objInvoices.OrderID;
		}
		if (this.objInvoices.ShipperName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ShipperName like '%" + this.objInvoices.ShipperName + "%'";
			else
				this.filterExpression = "ShipperName like '%" + this.objInvoices.ShipperName + "%'";
		}
		if (this.objInvoices.ProductID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ProductID = " + this.objInvoices.ProductID;
			else
				this.filterExpression = "ProductID = " + this.objInvoices.ProductID;
		}
		if (this.objInvoices.ProductName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ProductName like '%" + this.objInvoices.ProductName + "%'";
			else
				this.filterExpression = "ProductName like '%" + this.objInvoices.ProductName + "%'";
		}
		if (this.objInvoices.UnitPrice)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND UnitPrice = " + this.objInvoices.UnitPrice;
			else
				this.filterExpression = "UnitPrice = " + this.objInvoices.UnitPrice;
		}
		if (this.objInvoices.Quantity)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Quantity = " + this.objInvoices.Quantity;
			else
				this.filterExpression = "Quantity = " + this.objInvoices.Quantity;
		}
		if (this.objInvoices.ExtendedPrice)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ExtendedPrice = " + this.objInvoices.ExtendedPrice;
			else
				this.filterExpression = "ExtendedPrice = " + this.objInvoices.ExtendedPrice;
		}
		if (this.objInvoices.Freight)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Freight = " + this.objInvoices.Freight;
			else
				this.filterExpression = "Freight = " + this.objInvoices.Freight;
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}



	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Invoices/InvoicesSearch.component.ts